import { useClickstream } from '@zenbusiness/application-commons-clickstream';

export const defaultPayload = {
  appPageName: 'zb_banking_dashboard'
};

export const defaultPayloadButtonPressed = {
  ...defaultPayload
};

export const defaultPayloadBannerDisplayed = {
  ...defaultPayload
};
export default function useTrackEvent() {
  const { buttonPressed, modalDisplayed, linkPressed, pageDisplayed, bannerViewed } =
    useClickstream();

  const buttonPressedTracker = (payload) =>
    buttonPressed({
      ...defaultPayload,
      component: 'zb_banking',
      pageCategory: 'dashboard',
      ...payload
    });

  const linkPressedTracker = (payload) =>
    linkPressed({
      ...defaultPayload,
      component: 'zb_banking',
      ...payload
    });
  const modalDisplayedTracker = (payload) =>
    modalDisplayed({
      ...defaultPayload,
      component: 'zb_banking',
      pageCategory: 'dashboard',
      customDestinationPageName_: '',
      ...payload
    });

  const pageDisplayedTracker = (payload) =>
    pageDisplayed({
      ...defaultPayload,
      customDestinationPageName_: '',
      pageCategory: 'dashboard',
      ...payload
    });

  const bannerDisplayedTracker = (payload) =>
    bannerViewed({
      ...defaultPayload,
      ...payload
    });

  return {
    linkPressedTracker,
    buttonPressedTracker,
    pageDisplayedTracker,
    modalDisplayedTracker,
    bannerDisplayedTracker
  };
}
